var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMoveUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8,
  transform: "rotate(180 9 9)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M9 13V6m3.5 3L9.376 5.43a.5.5 0 0 0-.752 0L5.5 9"
}))));
export default SvgIconMoveUp;